module.exports = __webpack_public_path__ + "img/bed_offline.491997d1.png";